import type { CsvAnalyzeResponse, CsvParseResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { FileImportApiGateway } from './file-import-api';

/**
 * Real HTTP implementation of the shared file-import read layer. Request
 * shapes are kept 1:1 with the original FileImportStepper so the server sees
 * identical requests; every list-feature gateway spreads this in.
 */
export const fileImportApiHttp: FileImportApiGateway = {
  parseFile: (file, options) => {
    const formData = new FormData();
    formData.append('file', file);
    // With a progress listener, the upload goes through XHR (fetch cannot report it).
    return options
      ? api.uploadWithProgress<CsvParseResponse>('/csv/parse', formData, options)
      : api.upload<CsvParseResponse>('/csv/parse', formData);
  },

  analyzeRows: (request) => api.post<CsvAnalyzeResponse>('/csv/analyze', request),
};
